import React, { Component } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
} from 'react-router-dom';

import Privacy from './Components/Privacy';
import Terms from './Components/Terms';
import Security from './Components/Security';
import Login from './Components/Login';
import EmailConfirmation from './Components/EmailConfirmation';
import Signup from './Components/Signup';
import Dashboard from './Components/Dashboard';
import ForgotPassword from './Components/ForgotPassword';
import NewPassword from './Components/NewPassword/NewPassword';
import NewTextbox from './Components/NewTextbox';
import NewTextboxResult from './Components/NewTextboxResult';
import KeysPage from './Components/KeysPage';
import MessagesPage from './Components/MessagesPage';
import Instructions from './Components/Instructions';
import ScanQrCode from './Components/ScanQrCode/ScanQrCode';
import EncryptedTextView from './Components/EncryptedTextView';
import AuthCallback from './Components/Auth/AuthCallback';
import NotFound from './Components/NotFound';

class Router extends Component {
  render() {
    return (
      <BrowserRouter>
        <div className="position-relative">
          <Routes>
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/security" element={<Security />} />
            <Route path="/create_encrypted_text" element={<NewTextbox />} />
            <Route path="/encrypted_text_result" element={<NewTextboxResult />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/resetpassword" element={<NewPassword />} />
            <Route path="/resetpassword/:resetHash" element={<NewPassword />} />
            <Route path="/emailconfirmation/:confirmationHash" element={<EmailConfirmation />} />
            <Route path="/keys" element={<KeysPage />} />
            <Route path="/messages" element={<MessagesPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/decrypt" element={<ScanQrCode />} />
            <Route path="/encrypted_text_view/:id" element={<EncryptedTextView />} />
            <Route path="/info" element={<Instructions />} />
            <Route path="/" element={<Dashboard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </BrowserRouter>
    );
  }
}

export default Router;
